module.exports = __webpack_public_path__ + "static/media/article.3188c41a.jpg";